const PROJECT_LINK_HOSTNAME_PATTERN =
  /^(?=.{1,253}$)(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/
const PROJECT_LINK_PROTOCOLS = new Set(["http:", "https:"])

export const isValidProjectLink = value => {
  const trimmedValue = value.trim()
  const linkValue = /^www\./i.test(trimmedValue)
    ? `https://${trimmedValue}`
    : trimmedValue

  try {
    const url = new URL(linkValue)
    const hostnameLabels = url.hostname.split(".")
    const hasCompleteWwwDomain =
      hostnameLabels[0].toLowerCase() !== "www" || hostnameLabels.length >= 3

    return (
      PROJECT_LINK_PROTOCOLS.has(url.protocol) &&
      hasCompleteWwwDomain &&
      PROJECT_LINK_HOSTNAME_PATTERN.test(url.hostname)
    )
  } catch {
    return false
  }
}
